<template>
  <div bg-hex-f7f7f7 v-if="!!store.global?.details?.voteInfo" style="padding: 20px;margin-top: 24px">
    <div class="vote-title droidSerif-bold">
      <div class="vote-extra">
        <img src="/src/assets/extraIcon/vote.png" alt="vote icon">
        <span class="extra droidSerif-bold">Vote</span>
      </div>
      {{ store.global?.details?.voteInfo?.title }}
    </div>
    <div
      v-if="store.global?.details?.voteInfo?.endTime"
      :class="[ 'flex items-center' ]"
      :style="{
        gap: '8px',
        marginBottom: store.global?.details?.voteInfo?.style === 2 && !voteisEx ? '30px' : '24px'
      }"
    >
      <span
        v-if="!voteisEx"
        class="droidSerif-bold text-hex-000"
        style="font-size: 14px;line-height: 20px"
      >
        {{ voteisEx ? 'Deadline' : 'Closed' }}
      </span>
      <span
        v-if="store.global?.details?.voteInfo?.endTime"
        class="droidSerif text-hex-5A5A5A"
        style="font-size: 14px;line-height: 20px"
      >
        {{ dayjs(Number(store.global?.details?.voteInfo.endTime)).format('HH:mm, MMM DD, YYYY') }}
      </span>
    </div>
    <div v-if="store.global?.details?.voteInfo?.style === 1" :class="[ 'vote-sigle', voteisEx ? 'flex' : 'flex ex' ]">
      <div
        @click="download"
        class="vote-item droidSerif-bold"
        :class="voteStyle === 1 ? key === 0 ? 'one' : key === 1 ? 'two' : '' : ''"
        :style="key === 0 && voteStyle === 1 ? item.oneStyle : key === 1 && voteStyle === 1 ? item.twoStyle : undefined"
        v-for="(item, key) in voteList"
        :key="item.optionId"
      >
        <span v-if="voteisEx">{{ item.summary }}</span>
        <template v-else>
          <div class="details" style="font-size: 16px;line-height: 24px">Choose"{{ item.summary }}"</div>
          <div class="progress" style="font-size: 16px;line-height: 24px">{{ item.votesBf }}%</div>
        </template>
      </div>
    </div>
    <div v-if="store.global?.details?.voteInfo?.style === 2" flex flex-wrap :class="[ 'vote-more' , voteisEx ? '' : 'ex items-stretch' ]">
      <div
        @click="download"
        class="vote-item droidSerif-bold"
        v-for="(item, index) in voteList"
        :key="item.optionId"
        :style="{
          background: voteisEx
            ? index % 2 === 0 ? `linear-gradient(270deg, #63D4FF 0%, #50BDE7 100%)` : `linear-gradient(270deg, #486FFF 0%, #5A88FF 100%)` : undefined
        }"
      >
        <span v-if="voteisEx">{{ item.summary }}</span>
        <template v-else>
          <div class="details w-full flex justify-between text-hex-080808" style="font-size: 18px;line-height: 20px">
            <span>{{ item.summary }}</span>
            <span>{{ item.votesBf }}%</span>
          </div>
          <div class="progress" style="margin-top: 30px">
            <div class="progress-item" :style="{ 'width': item.votesBf + '%', height: '12px' }"></div>
            <div class="progress-item" :style="{ 'width':(100 - item.votesBf) + '%', height: '12px' }"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { useStore } from '@gx-vuex'
import img_yes from '@/assets/extraIcon/img_yes.png'
import img_no from '@/assets/extraIcon/img_no.png'
import { isDev, typeViteEnv } from '@/utils/env'
import { cloneDeep } from 'lodash-unified'
import { ref } from 'vue'

const store = useStore()
const contentId = document.querySelector('body').getAttribute('data-id')

type VoteList = {
  index?: number;
  optionId?: string;
  summary?: string;
  totalVotes?: number;
  votesBf?: string | number;
  oneStyle?: any;
  twoStyle?: any;
}

const voteList = ref<VoteList[]>([])

const voteisEx = computed(() => {
  if (store.global?.details?.voteInfo?.endTime)
    return dayjs().isBefore(dayjs(Number(store.global?.details?.voteInfo?.endTime)))
  return true
})

const totalVoteNum = computed(() => {
  return (store.global?.details?.voteInfo?.options || []).reduce((x, i) => {
    return x + (i.totalVotes || 0)
  }, 0)
})

const voteStyle = computed(() => {
  return store.global?.details?.voteInfo.style
})

const download = () => {
  if (!voteisEx.value) return
  window.open(`${isDev()
    ? typeViteEnv('VITE_BASE_HOMEPAGE_URL')
    : location.origin}/publicity?contentType=article&contentId=${contentId}`)
}

onMounted(() => {
  const time = setInterval(() => {
    if (document.querySelector('.vote-title')) {
      clearInterval(time)
      let list: any[] = cloneDeep(store.global?.details?.voteInfo?.options).map(item => {
        return {
          votesBf: totalVoteNum.value ? parseInt(item.totalVotes / totalVoteNum.value * 100) : 0,
          ...item
        }
      })
      
      if (totalVoteNum.value && list.length > 0) {
        let bfTols = 0
        let bfMax = list[0].votesBf
        let index = 0
        let bfgDiff = 0
        for (let i = 0; i < list.length; i++) {
          bfTols += list[i].votesBf
          if (bfMax < list[i].votesBf) {
            bfMax = list[i].votesBf
            index = i
          }
        }
        bfgDiff = bfTols - 100
        if (bfgDiff > 0) {
          list[index] = bfMax - bfgDiff
        } else if (bfgDiff < 0) {
          list[index] = bfMax + Math.abs(bfgDiff)
        } else {}
      } else if (list.length > 0 && voteStyle.value === 1) {
        if (list[0].votesBf === 0 && list[1].votesBf === 0) {
          list = list.map(item => {
            return {
              ...item,
              votesBf: 50
            }
          })
        }
      }
      
      voteList.value = cloneDeep(list || []).map((item, index) => {
        const voteWidth = document.querySelector('.vote-title')
          ? document.querySelector('.vote-title').getBoundingClientRect().width
          : 0
        const oneWidth = store.global?.details?.voteInfo.style == 1 && index === 0
          ? list[index + 1].votesBf == 0 && item.votesBf == 0
            ? 50
            : (item.votesBf == 0 ? 15 : list[index + 1].votesBf == 0 ? 85 : item.votesBf)
          : 0
        const twoWidth = store.global?.details?.voteInfo.style == 1 && index === 1
          ? list[index - 1].votesBf == 0 && item.votesBf == 0
            ? 50
            : (item.votesBf == 0 ? 15 : list[index - 1].votesBf == 0 ? 85 : item.votesBf)
          : 0
        
        return {
          ...item,
          oneStyle: {
            width: `${oneWidth}%`,
            clipPath: `polygon(0 0, 100% 0, ${voteWidth * (oneWidth / 100) - 4}px 100%, 0 100%)`
          },
          twoStyle: {
            width: `${twoWidth}%`,
            clipPath: `polygon(4px 0, 100% 0, 100% 100%, 0 100%)`
          }
        }
      })
    }
  }, 200)
})
</script>

<style lang="less" scoped>
.vote-title {
  color: #fff;
  font-size: 24px;
  line-height: 30px;
  margin-bottom: 12px;
  position: relative;
  color: #000;
  word-break: break-word;
}

.vote-extra {
  float: left;
  height: 30px;
  align-items: center;
  display: flex;
  float: left;
  margin-right: 8px;
  text-indent: 0;
  
  img {
    width: 24px;
    height: 24px;
  }
  
  .extra {
    font-size: 14px;
    padding: 0 4px;
    height: 24px;
    line-height: 24px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
  }
}

.vote-sigle, .vote-more {
  &.ex {
    .vote-item {
      padding: 9px;
      cursor: unset;
      flex-direction: column;
      
      .details {
        gap: 10px;
        
        span {
          &:first-child {
            word-break: break-word;
          }
          
          &:last-child {
            flex-shrink: 0;
          }
        }
      }
    }
  }
  
  .vote-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 430px;
    padding: 21px 16px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    word-break: break-word;
    font-size: 18px;
    color: #FFFFFF;
    cursor: pointer;
    
    &.one {
      background: linear-gradient(270deg, #486FFF 0%, #5A88FF 100%);
      border-top-left-radius: 1px;
      border-top-right-radius: 1.5px;
      border-bottom-right-radius: 1px;
    }
    
    &.two {
      background: linear-gradient(270deg, #63D4FF 0%, #50BDE7 100%);
      border-top-left-radius: 1px;
      border-top-right-radius: 1px;
      border-bottom-left-radius: 1.5px;
    }
    
    span {
      text-align: center;
      line-height: 30px;
    }
  }
}

.vote-more {
  gap: 20px;
  
  &.ex {
    justify-content: space-between;
    
    .vote-item {
      justify-content: space-between;
      padding: 0;
      border-radius: 0;
    }
    
    .progress {
      width: 100%;
      display: flex;
      align-items: center;
      
      .progress-item {
        border-radius: 2px;
        
        &:first-child {
          background: linear-gradient(270deg, #E5111E 0%, #FFB5B9 100%);
        }
        
        &:last-child {
          background: #ececec;
        }
      }
    }
  }
  
  .vote-item {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    width: 412px;
    
    span {
      text-align: left;
    }
  }
}
</style>
